/**
 * Detect fn
 */
export default () => self.Reflect && 'construct' in self.Reflect
